import { createContext } from "react";
import { IFeatureFlagContext } from "@common/FeatureFlagProvider/IFeatureFlagContext";

export const FeatureFlagContext = createContext<IFeatureFlagContext>({
    getIsFeatureEnabled: () => false,
});
